import { Row, Col, Form, Input, Button } from "antd";
import POSLogo from "../../../../assets/images/NewLogoCW.svg";
import Online from "../../../../assets/images/green.svg";
import Offline from "../../../../assets/images/red.svg";
import userIcon from "../../../../assets/images/userId.svg";
import useAuthStore from "../../../../stores/useAuthStore";

const ORDER_CARDS_ROW1 = [
  {
    title: "Sales Quotation",
    desc: "Create a new price quote for a customer",
    btnText: "Create Quotation",
  },
  {
    title: "Sales Order",
    desc: "Create a new customer order",
    btnText: "Create Order",
  },
];

const ORDER_CARDS_ROW2 = [
  {
    title: "Sales Invoice",
    desc: "Generate a new invoice for completed orders",
    btnText: "Create Invoice",
  },
  {
    title: "Proforma Invoice",
    desc: "Create a preliminary invoice for estimates",
    btnText: "Create Proforma Invoice",
  },
];

const SMOrderSelectionView = ({
  colorVariable,
  isSectionVisible,
  isOnline,
  form,
  onFinish,
  showOrderSelection,
  setShowOrderSelection,
  setIsSectionVisible,
}) => {
  return (
    <div
      style={{
        backgroundColor: colorVariable || "#f3f4f9",
        height: "100vh",
        width: "100%",
        display: isSectionVisible ? "block" : "none",
        position: "relative",
      }}
    >
      {/* Header Section */}
      <Row style={{ height: "9vh", background: "", padding: "0.8% 0", position: "absolute", width: "100%" }}>
        <Col span={6}>
          <img
            src={POSLogo}
            style={{
              height: "2.8vw",
              paddingLeft: "1vw",
              paddingTop: "1vh",
            }}
          />
        </Col>
        <Col
          span={18}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            paddingRight: "1%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "center",
              padding: "0.5vw",
              border: "1px solid #3C424B",
              borderRadius: "50%",
            }}
          >
            <img src={userIcon} style={{ height: "2.7vh" }} />
          </div>
          <span
            style={{
              color: "#0F0718",
              fontSize: "1vw",
              fontFamily: "Inter",
              padding: "0 2%",
              fontWeight: "600",
              wordWrap: "break-word",
            }}
          >
            Till ID : {useAuthStore.getState().tillValue?.name}
          </span>
          <div style={{ paddingRight: "2%" }}>
            <img src={isOnline ? Online : Offline} style={{ height: "3.5vh", cursor: "pointer" }} /> &nbsp;
          </div>
        </Col>
      </Row>

      {!showOrderSelection ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
              marginBottom: "20px",
              width: "100%",
            }}
          >
            {ORDER_CARDS_ROW1.map((card, index) => (
              <Col key={index} xs={24} sm={12} md={6}>
                <div
                  style={{
                    background: "white",
                    padding: "1.1rem",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    height: "25vh",
                    position: "relative",
                    display: "flex",
                    width: "25vw",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <h3 style={{ fontSize: "1.2rem", fontWeight: "600", margin: 0 }}>{card.title}</h3>
                    <p style={{ fontSize: "0.7rem", color: "#666" }}>{card.desc}</p>
                  </div>
                  <button
                    style={{
                      background: "#242B3A",
                      color: "white",
                      padding: "7px 20px",
                      border: "none",
                      borderRadius: "3px",
                      cursor: "pointer",
                      width: "100%",
                    }}
                    onClick={() => setShowOrderSelection(true)}
                  >
                    {card.btnText}
                  </button>
                </div>
              </Col>
            ))}
          </Row>
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              gap: "20px",
            }}
          >
            {ORDER_CARDS_ROW2.map((card, index) => (
              <Col key={index} xs={24} sm={12} md={6}>
                <div
                  style={{
                    background: "white",
                    padding: "1.1rem",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    height: "25vh",
                    position: "relative",
                    display: "flex",
                    width: "25vw",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <h3 style={{ fontSize: "1.2rem", fontWeight: "600", margin: 0 }}>{card.title}</h3>
                    <p style={{ fontSize: "0.7rem", color: "#666" }}>{card.desc}</p>
                  </div>
                  <button
                    style={{
                      background: "#242B3A",
                      color: "white",
                      padding: "7px 20px",
                      border: "none",
                      borderRadius: "3px",
                      cursor: "pointer",
                      width: "100%",
                    }}
                  >
                    {card.btnText}
                  </button>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      ) : (
        <Row justify="center" align="middle" style={{ height: "100vh" }}>
          <Col xs={22} sm={16} md={12} lg={10} xl={8}>
            <h2 style={{ textAlign: "left", marginBottom: "20px" }}>Create Sales Invoice</h2>
            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Form.Item name="customerName" label="Customer Name" style={{ marginBottom: "15px" }} rules={[{ required: false, message: "Please enter the customer name" }]}>
                <Input />
              </Form.Item>

              <Form.Item name="email" label="Email" style={{ marginBottom: "15px" }} rules={[{ type: "email", message: "Please enter a valid email" }]}>
                <Input />
              </Form.Item>

              <Form.Item name="phone" label="Phone Number" style={{ marginBottom: "15px" }} rules={[{ required: false, message: "Please enter the phone number" }]}>
                <Input />
              </Form.Item>

              <Form.Item name="address" label="Address" style={{ marginBottom: "15px" }}>
                <Input.TextArea />
              </Form.Item>

              <Form.Item>
                <Button
                  onClick={() => {
                    setShowOrderSelection(true);
                    setIsSectionVisible(false);
                  }}
                  style={{ width: "11vw", backgroundColor: "#242B3A", color: "#fff", textAlign: "center" }}
                  htmlType="submit"
                  block
                >
                  Next: Add Items
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default SMOrderSelectionView;
